export const leadConstants = {

  ADD_LEAD_REQUEST: "ADD_LEAD_REQUEST",
  ADD_LEAD_SUCCESS: "ADD_LEAD_SUCCESS",
  ADD_LEAD_FAILURE: "ADD_LEAD_FAILURE",

  GET_LEADS_REQUEST: "GET_LEADS_REQUEST",
  GET_LEADS_SUCCESS: "GET_LEADS_SUCCESS",
  GET_LEADS_FAILURE: "GET_LEADS_FAILURE",

  UPLOAD_EXCEL_REQUEST: "UPLOAD_EXCEL_REQUEST",
  UPLOAD_EXCEL_SUCCESS: "UPLOAD_EXCEL_SUCCESS",
  UPLOAD_EXCEL_FAILURE: "UPLOAD_EXCEL_FAILURE",

  EDIT_LEAD_REQUEST: "EDIT_LEAD_REQUEST",
  EDIT_LEAD_SUCCESS: "EDIT_LEAD_SUCCESS",
  EDIT_LEAD_FAILURE: "EDIT_LEAD_FAILURE",

  ADD_NOTES_REQUEST: "ADD_NOTES_REQUEST",
  ADD_NOTES_SUCCESS: "ADD_NOTES_SUCCESS",
  ADD_NOTES_FAILURE: "ADD_NOTES_FAILURE",
  ADD_NOTES_CLEAR: "ADD_NOTES_CLEAR",

  CHANGE_TO_SALE_OPPORTUNITY_REQUEST: "CHANGE_TO_SALE_OPPORTUNITY_REQUEST",
  CHANGE_TO_SALE_OPPORTUNITY_SUCCESS: "CHANGE_TO_SALE_OPPORTUNITY_SUCCESS",
  CHANGE_TO_SALE_OPPORTUNITY_FAILURE: "CHANGE_TO_SALE_OPPORTUNITY_FAILURE",

  PIN_LEAD_REQUEST: "PIN_LEAD_REQUEST",
  PIN_LEAD_SUCCESS: "PIN_LEAD_SUCCESS",
  PIN_LEAD_FAILURE: "PIN_LEAD_FAILURE",

  EDIT_CONTACT_INFORMATION_REQUEST: "EDIT_CONTACT_INFORMATION_REQUEST",
  EDIT_CONTACT_INFORMATION_SUCCESS: "EDIT_CONTACT_INFORMATION_SUCCESS",
  EDIT_CONTACT_INFORMATION_FAILURE: "EDIT_CONTACT_INFORMATION_FAILURE",

  GET_CANCELLATION_REASON_REQUEST: "GET_CANCELLATION_REASON_REQUEST",
  GET_CANCELLATION_REASON_SUCCESS: "GET_CANCELLATION_REASON_SUCCESS",
  GET_CANCELLATION_REASON_FAILURE: "GET_CANCELLATION_REASON_FAILURE",

  CANCEL_LEAD_REQUEST: "CANCEL_LEAD_REQUEST",
  CANCEL_LEAD_SUCCESS: "CANCEL_LEAD_SUCCESS",
  CANCEL_LEAD_FAILURE: "CANCEL_LEAD_FAILURE",


  ACCEPT_LEAD_REQUEST: "ACCEPT_LEAD_REQUEST",
  ACCEPT_LEAD_SUCCESS: "ACCEPT_LEAD_SUCCESS",
  ACCEPT_LEAD_FAILURE: "ACCEPT_LEAD_FAILURE",



};

